import { render, staticRenderFns } from "./GetApiKey.vue?vue&type=template&id=3565a2a0&scoped=true&"
import script from "./GetApiKey.vue?vue&type=script&lang=js&"
export * from "./GetApiKey.vue?vue&type=script&lang=js&"
import style0 from "./GetApiKey.vue?vue&type=style&index=0&id=3565a2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565a2a0",
  null
  
)

export default component.exports